import React, { useState } from 'react';
import { Droppable } from '@hello-pangea/dnd';
import TodoHeader from './todo/TodoHeader';
import TodoForm from './todo/TodoForm';
import TodoItem from './todo/TodoItem';
import { EyeIcon } from './icons/EyeIcon';
import {
    TodoListContainer,
    Progress,
    ProgressBar,
    TodoContent,
    ToggleButton
} from '../styles/TodoList.styles';

function TodoList({
    todos,
    onAddTodo,
    onToggleTodo,
    onDeleteTodo,
    onUpdateTodo,
    onConvertToCard,
    onConvertAllToCards,
    onReorder,
    title = "Checklist",
    placeholder = "Add a todo item",
    className,
    isCollapsed,
    onCollapse,
    limitColumnHeight
}) {
    const [hideCompleted, setHideCompleted] = useState(false);

    const calculateProgress = () => {
        if (!todos.length) return 0;
        const completed = todos.filter(todo => todo.completed).length;
        return Math.round((completed / todos.length) * 100);
    };

    const visibleTodos = hideCompleted
        ? todos.filter(todo => !todo.completed)
        : todos;

    const incompleteTodos = todos.filter(todo => !todo.completed);
    const completedCount = todos.filter(todo => todo.completed).length;

    // Function to get original index from filtered index
    const getOriginalIndex = (filteredIndex) => {
        if (!hideCompleted) return filteredIndex;
        const visibleTodo = visibleTodos[filteredIndex];
        return todos.findIndex(todo => todo.id === visibleTodo.id);
    };

    return (
        <TodoListContainer className={className} limitColumnHeight={limitColumnHeight}>
            <TodoHeader
                title={title}
                isCollapsed={isCollapsed}
                todos={todos}
                hideCompleted={hideCompleted}
                setHideCompleted={setHideCompleted}
                incompleteTodos={incompleteTodos}
                onConvertAllToCards={onConvertAllToCards}
                onCollapse={onCollapse}
                onAddTodo={onAddTodo}
            />

            <TodoContent isCollapsed={isCollapsed}>
                <TodoForm
                    onAddTodo={onAddTodo}
                    placeholder={placeholder}
                />

                {todos.length > 0 && (
                    <Progress>
                        <ProgressBar percentage={calculateProgress()} />
                    </Progress>
                )}

                <Droppable droppableId="checklist-items" type="CHECKLIST_ITEM">
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {visibleTodos.map((todo, index) => (
                                <TodoItem
                                    key={todo.id}
                                    todo={todo}
                                    index={index}
                                    onToggle={() => onToggleTodo(getOriginalIndex(index))}
                                    onDelete={() => onDeleteTodo(getOriginalIndex(index))}
                                    onUpdate={(newText) => onUpdateTodo(getOriginalIndex(index), newText)}
                                    onConvert={onConvertToCard && (() => onConvertToCard(todo))}
                                    showConvert={!todo.completed && onConvertToCard}
                                    isParentCollapsed={isCollapsed} // Pass down the collapsed state
                                />
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>

                {hideCompleted && completedCount > 0 && (
                    <ToggleButton
                        onClick={() => setHideCompleted(false)}
                        style={{ marginTop: '12px' }}
                    >
                        <EyeIcon hidden={false} />
                    </ToggleButton>
                )}
            </TodoContent>
        </TodoListContainer>
    );
}

export default TodoList;
